// extracted by mini-css-extract-plugin
export var errorsContainer = "_sn-1";
export var link = "_sn-0";